<template>
<div class="container unprint">
  <div class="row">
    <div class="slopePage__title">
      <b>Альбомы и инструкции по материалам и монтажу</b>
    </div>
  </div>
  <div class="row addons">
    <div class="col-lg-4 addons__item" v-for="(item, i) in albums" :key="i">
      <a :href="item.link" class="addons__link" target="_blank">
        <img src="@/assets/img/download.svg" alt="downlad" class="addons__link-img">
        {{ item.name }}
      </a>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    materialProp: Number,
  },
  data() {
    return {
      links: [
        {
          id: 0,
          name: 'Инструкция по устройству клинов',
          link: 'https://www.google.com/',
        },
      ],
    };
  },
  components: {
  },
  computed: {
    filteredFasteners() {
      return this.isShowRemaining ? this.fasteners : this.fasteners.slice(0, 6);
    },
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    index() {
      return this.allMaterials.findIndex(p => p.id === this.materialProp);
    },
    result() {
      return this.$store.getters.getResult;
    },
    albums() {
      return this.result.sections[this.$route.params.id].albums;
    },
  },
};
</script>

<style lang="sass" scoped>
.detailsPage
  .slopePage
    &__title
      +media((font-size: (320: rem(18), 992: rem(24))))
      +media((line-height: (320: rem(26), 992: rem(29))))
      +media((padding-top: (320: rem(45), 992: rem(70))))
      +media((padding-bottom: (320: rem(30), 992: rem(36))))
</style>
